import { ErrorModalContent, Modal } from 'components';
import { selectModalsErrors } from 'store/app/selectors';
import { useSelector } from 'store/utils';

type Props = {
  onClose(): void;
};

export const ErrorModal = ({ onClose }: Props) => {
  const errorMessage = useSelector(selectModalsErrors).patientComplainError;
  return (
    <Modal title="Patient complaints" onClose={onClose}>
      <ErrorModalContent
        onConfirm={onClose}
        title="Patient's complaints are not updated"
        subtitle={`Updates to the patient's complaints were not saved${errorMessage ? `. ${errorMessage}` : 'due to technical reasons'}`}
      />
    </Modal>
  );
};
